import axios from "axios";

const API = "https://nathnagribareilly.com/api/index.php";

export const getSEO = async (page) => {
    try {
        const res = await axios.get(`${API}?action=getSEO&page=${page}`);
        return res.data;
    } catch (err) {
        console.error("SEO fetch error", err);
        return null;
    }
};